import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { useT } from "../lib/i18n";

const KEY = "anaiza_cookie_consent_v1";

export default function CookieBanner() {
  const { t } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setShow(true);
  }, []);

  const accept = (level) => {
    localStorage.setItem(KEY, JSON.stringify({ level, ts: Date.now() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 pb-20 md:pb-6 px-3 md:px-6" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto border border-gray-900 bg-white shadow-2xl">
        <div className="p-5 md:p-7 flex flex-col md:flex-row gap-5 md:gap-7">
          <div className="flex-shrink-0">
            <div className="w-11 h-11 border border-gray-900 flex items-center justify-center">
              <Cookie size={22} strokeWidth={1.5} />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="font-display text-lg font-black tracking-tight">{t("cookie.title")}</h3>
            <p className="mt-2 text-sm text-gray-600 leading-relaxed">
              {t("cookie.body")} {t("cookie.body.cta")} <Link to="/politica-de-cookies" className="underline underline-offset-2 font-semibold text-gray-900">{t("cookie.policy.link")}</Link>.
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
              <button
                onClick={() => accept("all")}
                className="bg-gray-900 text-white px-5 py-2.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-gray-800 transition"
                data-testid="cookie-accept-all"
              >
                {t("cookie.accept")}
              </button>
              <button
                onClick={() => accept("essential")}
                className="border border-gray-900 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-gray-900 hover:text-white transition"
                data-testid="cookie-essential-only"
              >
                {t("cookie.essential")}
              </button>
            </div>
          </div>
          <button
            onClick={() => accept("essential")}
            aria-label={t("cookie.close")}
            className="absolute top-2 right-2 md:static md:self-start p-2 text-gray-400 hover:text-gray-900"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
